import { environment } from '../../../../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { EstablecimientoEntry } from 'src/app/shared/entrys/establecimiento.entry';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable, of } from 'rxjs';
import { retry } from 'rxjs/operators';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';


@Injectable()
export class RntConsultaService implements RequestCRUD<EstablecimientoEntry, ResponseServiceModel> {
	private API_URL;
	private handleError: HandleError;
	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private enviromentGlobalService: EnviromentGlobalService) {
		this.handleError = httpErrorHandler.createHandleError('SolicitudesService');
		this.API_URL = enviromentGlobalService.apiUrl;
	}

	get(entry: any): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	getSolicitudes(numeroPagina: number, entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>
			(`${this.API_URL}/ConsultaRnt/Obtener/1?PageNumber=${numeroPagina}&PageSize=12&QueryType=A`, entry).pipe(
				retry(2)
			);
	}
	getTiposSolicitud() {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/Solicitud/GetTipoSolicitudes`).pipe(
			retry(2)
		);
	}
	getEstadosSolicitudes() {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/EstadosSolicitud`).pipe(
			retry(2)
		);
	}

	getEstadosRnt() {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/EstadosRnt`).pipe(
			retry(2)
		);
	}
	sendAsignacion(entry: any) {
		return this.http.put<ResponseServiceModel>(`${this.API_URL}/Solicitud/AsignarSolicitud`, entry).pipe(
			retry(2)
		);
	}
	update(entry: any): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	create(entry: EstablecimientoEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	delete(entry: EstablecimientoEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}


}
